import type { UseFormReturn } from 'react-hook-form';
import { Labeled } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import type { IOrganizationUserFormValues } from './OrganizationUserForm';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';
import { OrganizationRoleSelector } from '~/components/organisms/fields/OrganizationRoleSelector';

export type IOrganizationUserFormMainSectionProps = IContainerProps & {
  form: UseFormReturn<IOrganizationUserFormValues>;
  mode: IFormMode;
};

export const OrganizationUserFormMainSection: React.FC<
  IOrganizationUserFormMainSectionProps
> = (props) => {
  const { sx, form } = props;
  const { t } = useTranslation();

  return (
    <FormSection sx={sx}>
      <Labeled label={t('common.role')} required>
        <FormField
          name="role"
          control={form.control}
          as={OrganizationRoleSelector}
          forwardError
        />
      </Labeled>
    </FormSection>
  );
};
